{
    "cookie_consent_title": "Ønsker du å se dette innholdet?",
    "cookie_consent_button": "Åpne innstillinger",
    "cookie_consent_description": {
        "type": "markdown",
        "value": "For å spille av denne videoen, trenger vi ditt samtykke."
    },
    "playVideo": "Spill av video",
    "hearVisualInterpretation": "Hør synstolkning av videoen",
    "doneVisualInterpretation": "Synstolkning av video er ferdig lest opp."
}
